import { React, useState } from "react";
import axios from "axios";
import PropTypes from "prop-types";
import { CreateValidateTextField } from "..";
import { Dialog, DialogTitle, Snackbar, Alert } from "@mui/material";

function AdminCreate(props) {
  const { updateTable, setUpdateTable } = props;

  const [openCreateDialog, setOpenCreateDialog] = useState(false);

  const [firstName, setFirstName] = useState("");
  const [lastName, setLastName] = useState("");
  const [email, setEmail] = useState("");
  const [username, setUsername] = useState("");

  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState("");

  const handleAdminCreate = (event) => {
    event.preventDefault();
    const body = new FormData();
    body.append("firstName", firstName);
    body.append("lastName", lastName);
    body.append("email", email);
    body.append("pid", username);
    axios.post("/admin/createAdmin", body).then((res) => {
      const data = res.data;
      if (data.success) {
        resetHooks();
        setOpenCreateDialog(false);
        setUpdateTable(!updateTable);
      } else {
        setSnackbarMessage(data.message);
        setSnackbarOpen(true);
      }
    });
  };

  const resetHooks = () => {
    setFirstName("");
    setLastName("");
    setEmail("");
    setUsername("");
  };

  function showCreateDialog(open) {
    return (
      <Dialog open={open} maxWidth={false}>
        <DialogTitle className="AdminCreate-title mx-auto text-2xl font-bold font-brand-primary">
          Create An Admin
        </DialogTitle>
        <div className="AdminCreate-modalContainer flex flex-col w-fit px-4">
          <div className="AdminCreate-nameContainer flex flex-col w-96 mx-auto mb-2">
            <div className="AdminCreate-name text-lg font-brand-primary">
              First Name *
            </div>
            <CreateValidateTextField
              placeholder="John"
              pattern="[a-zA-Z-]+( [a-zA-Z-]+)*"
              value={firstName}
              setter={setFirstName}
              errorMessage={"Invalid First Name."}
              required={true}
            />
          </div>
          <div className="AdminCreate-nameContainer flex flex-col w-96 mx-auto mb-2">
            <div className="AdminCreate-name text-lg font-brand-primary">
              Last Name *
            </div>
            <CreateValidateTextField
              placeholder="Doe"
              pattern="[a-zA-Z-]+( [a-zA-Z-]+)*"
              value={lastName}
              setter={setLastName}
              errorMessage={"Invalid Last Name."}
              required={true}
            />
          </div>
          <div className="AdminCreate-usernameContainer flex flex-col w-96 mx-auto mb-2">
            <div className="AdminCreate-username text-lg font-brand-primary">
              Username *
            </div>
            <CreateValidateTextField
              placeholder="jDoe"
              pattern="\w+"
              value={username}
              setter={setUsername}
              errorMessage={"Invalid username."}
              required={true}
            />
          </div>
          <div className="AdminCreate-emailContainer flex flex-col w-96 mx-auto mb-2">
            <div className="AdminCreate-email text-lg font-brand-primary">
              Email *
            </div>
            <CreateValidateTextField
              placeholder="jDoe@vt.com"
              pattern="[a-zA-Z0-9\._%\+\-]+@[a-zA-Z0-9\.\-]+\.[a-zA-Z]{2,4}"
              value={email}
              setter={setEmail}
              errorMessage={"Invalid Email."}
              required={true}
            />
          </div>
          <div className="AdminCreate-buttonContainer flex justify-between px-8">
            <button
              type="button"
              className="AdminCreate-createButton primary-button bg-brand-quaternary mb-2 h-11 pt-3 mr-4"
              onClick={handleAdminCreate}
            >
              Create
            </button>

            <button
              type="button"
              className="AdminCreate-cancelButton primary-button bg-brand-primary mb-2 h-11 pt-3"
              onClick={() => {
                setOpenCreateDialog(false);
                resetHooks();
              }}
            >
              Cancel
            </button>
          </div>
        </div>
        <Snackbar
          open={snackbarOpen}
          anchorOrigin={{ vertical: "top", horizontal: "center" }}
          autoHideDuration={6000}
          onClose={() => {
            setSnackbarOpen(false);
            setSnackbarMessage("");
          }
          }
        >
          <Alert
            onClose={() => {
              setSnackbarOpen(false);
              setSnackbarMessage("");
            }
            }
            severity="error"
            sx={{ width: "100%" }}
          >
            {snackbarMessage}
          </Alert>
        </Snackbar>
      </Dialog>
    );
  }

  return (
    <div className="AdminCreate-container">
      {showCreateDialog(openCreateDialog)}
      <button
        type="button"
        className="AdminCreate-button search-button px-4 h-11 mb-4 mr-4 text-center py-2"
        onClick={() => setOpenCreateDialog(true)}
      >
        Create an Admin
      </button>
    </div>
  );
}

AdminCreate.propTypes = {
  updateTable: PropTypes.bool,
  setUpdateTable: PropTypes.func,
};

AdminCreate.defaultProps = {
  updateTable: false,
  setUpdateTable: () => { },
};

export default AdminCreate;
